export const TIMELINE_STATUS = {
  past: 'past',
  current: 'current',
  closed: 'closed',
} as const
